module.exports = __webpack_public_path__ + "static/Pitch_Deck_Fall_2023-3f475719b3dd471f6d4f5916bfb702cc.pdf";